import { Button as AntdButton, ButtonProps } from "antd";
import classes from "./styles.module.css";

export function Button({ className = "", ...rest }: ButtonProps) {
  return <AntdButton {...rest} className={[classes.button].join(" ")} />;
}
